export const AppConfig = {
    site_name: "San Marino",
    title: "San Marino",
    description: "San marino description",
    locale: "es",
    api_url: process.env.NEXT_PUBLIC_BASE_URL,
  };
  